<svg id="bar">
</svg>
<div class="legend">
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th *ngFor="let name of tableHeaders">{{ name }}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <div class="legendTd">
            <div class="legendDotContainer">
              <div class="legendDot gdsDot"></div>
            </div>
            <div class="legendLabel">GDS</div>
          </div>
        </td>
        <td *ngFor="let row of chartData">{{ row.gds }}</td>
      </tr>
      <tr>
        <td>
          <div class="legendTd">
            <div class="legendDotContainer">
              <div class="legendDot onshoreDot"></div>
            </div>
            <div class="legendLabel">Onshore</div>
          </div>
        </td>
        <td *ngFor="let row of chartData">{{ row.onshore }}</td>
      </tr>
    </tbody>
  </table>


</div>
<div *ngIf="showLoader" class="loader-overlay">
  <div class="loader-overlay__loader"></div>
</div>
